import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from '../../common-pages.service';
import moment from 'moment';
import { AngularEditorConfig, UploadResponse } from '@kolkov/angular-editor';
import { ResponseStatus, ValidationMessage } from '../../enum';
import { SelectComponent } from 'select/select.component';

@Component({
  selector: 'app-add-update-announcement',
  templateUrl: './add-update-announcement.component.html',
  styleUrls: ['./add-update-announcement.component.scss'],
  standalone: false,
})
export class AddUpdateAnnouncementComponent implements OnInit {
  //#region properties
  @Output() hideAnnoucementDrawer = new EventEmitter();
  @Input() selectedAnnoucementData: any;
  isVisibleAnnouncementDrawer: boolean = true;
  isVisibleFullScreenModal: boolean = false;
  announcementDrawerTitle: string = 'Add Announcement';
  isSubmitting: boolean = false;
  @ViewChild('endDatePicker') endDatePicker!: NzDatePickerComponent;
  @ViewChild('AccountAndSitesGsSelect')
  AccountAndSitesGsSelect!: SelectComponent;
  yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
  sitesData: any[] = [];
  selectedSites: any[] = [];
  validationMessage = ValidationMessage;
  descFullScreen: any;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '15rem',
    maxHeight: '15rem',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter description here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'https://api.exapple.com/v1/image/upload',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [],
    upload: this.uploadImageByAngularEditor,
  };
  currentUploadedImageSize: any;
  files: any[] | undefined;
  showSitesInvalidMessage: boolean = false;
  isVisibleModal: boolean = false;
  currentDescription: any;
  //#endregion

  //constructor
  constructor(
    public _fS: FormService,
    private _cpS: CommonPagesService,
    public _cS: CommonService
  ) {
    _fS.announcementForm_fb();
  }

  //#region functions
  ngOnInit(): void {
    if (this.selectedAnnoucementData) {
      this.announcementDrawerTitle =
        'Edit Announcement (' + this.selectedAnnoucementData.title + ')';
      this._fS.announcementForm.patchValue({
        title: this.selectedAnnoucementData.title,
        desc: this.selectedAnnoucementData.description,
        start: this.selectedAnnoucementData.startOn,
        end: this.selectedAnnoucementData.endOn,
        isActive: this.selectedAnnoucementData.isActive,
      });
      this.selectedSites = this.selectedAnnoucementData.sites;
      this.getSitesData('PATCH');
    } else {
      this.getSitesData('GET');
    }
  }
  getSitesData(type: any) {
    this._cpS.GetSiteByAccount().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.sitesData = response.result;
        // this.sitesData.map((element: any) => {
        //   element['checked'] = false;
        //   element['search'] = true;
        //   element.parent = {
        //     checked: false,
        //     search: true,
        //     name: element.parent,
        //   };
        // });
        if (type == 'PATCH') {
          var count = 0;
          this.selectedAnnoucementData.sites.forEach((el: any) => {
            this.sitesData.map((parentelement: any) => {
              parentelement.children.map((childelement: any) => {
                if (el.id == childelement.id) {
                  childelement.checked = true;
                  childelement.search = true;
                }
              });
            });
          });
          this.sitesData.map((parentelement: any) => {
            parentelement.children.map((childelement: any) => {
              if (childelement.checked == true) {
                count++;
              }
            });

            //   if (count == parentelement.children.length) {
            parentelement['parent'] = {
              name: parentelement.parent,
              id: parentelement.children[0].accountId,
              // search: true,
              // checked: true,
            };
            //   } else {
            //     parentelement['parent'] = {
            //       name: parentelement.parent,
            //       id: parentelement.children[0].accountId,
            //       search: true,
            //       checked: false,
            //     };
            //   }
          });
        } else if (type == 'GET') {
          this.sitesData.map((el: any, i: any) => {
            el.children.map((e: any) => {
              {
                e.search = true;
                e.checked = false;
              }
            });
            el['parent'] = {
              name: el.parent,
              id: el.children[0].accountId,
              search: true,
              checked: false,
            };
          });
        }
        this.UpdateAccountAndSitesGsSelect();
      }
    });
  }
  sitesDropdownChanged(event: any) {
    this.selectedSites = [];
    event.forEach((element: any) => {
      element.children.forEach((child: any) => {
        if (child.checked == true) {
          this.selectedSites.push({ id: child.id, name: child.name });
        }
      });
    });

    this._fS.announcementForm.patchValue({
      sites: this.selectedSites,
    });
    if (this.selectedSites.length > 0) {
      this.showSitesInvalidMessage = false;
    } else {
      this.showSitesInvalidMessage = true;
    }
  }
  openInFullScreen() {
    this.isVisibleFullScreenModal = true;
    this.editorConfig['minHeight'] = '45rem';
    this.descFullScreen = this._fS.announcementForm.get('desc').value;
  }
  showPreviewModal() {
    if (this._fS.announcementForm.valid && this.selectedSites.length > 0) {
      this.isVisibleModal = true;
      this.currentDescription = this._fS.announcementForm.get('desc').value;
    } else {
      this._cS.markFormGroupTouched(this._fS.announcementForm);
      if (this.selectedSites?.length == 0) {
        this.showSitesInvalidMessage = true;
      }
    }
  }
  UpdateUploadedImageSize() {
    try {
      var ButtonElement = document.getElementById(
        'UpdateUploadedImageSizeButton'
      );
      this.currentUploadedImageSize = ButtonElement?.getAttribute(
        'currentUploadedImageSize'
      );
    } catch (ex) { }
  }

  uploadImageByAngularEditor(file: File): any {
    var url, img: any;
    let reader = new FileReader();

    img = new Image();
    img.onload = () => {
      var size = img.height + ' X ' + img.width;
      try {
        var ButtonElement = document.getElementById(
          'UpdateUploadedImageSizeButton'
        );
        ButtonElement?.setAttribute('currentUploadedImageSize', size);
        ButtonElement?.click();
      } catch (ex) { }
    };
    img.src = URL.createObjectURL(file);
    reader.onload = () => {
      url = reader.result;
      document.execCommand('insertHTML', false, `<img src='${url}'>`);
    };
    reader.abort();
    if (file) {
      reader.readAsDataURL(file);
    }
  }
  checkImageUploaded() {
    var descValue = this._fS.announcementForm.get('desc')?.value;
    if (!descValue.match(/<img/)) {
      this.currentUploadedImageSize = '';
    }
  }

  UpdateAccountAndSitesGsSelect() {
    if (this.AccountAndSitesGsSelect) {
      setTimeout(() => {
        this.AccountAndSitesGsSelect.dropDownChanged(false);
      }, 50);
    }
  }

  handleOk() {
    if (this._fS.announcementForm.valid && this.selectedSites.length > 0) {
      //'YYYY-MM-DDTHH:mm:ss'
      var utcStart = moment(this._fS.announcementForm.get('start').value)
        .utc()
        .format();
      var utcEnd = moment(this._fS.announcementForm.get('end').value)
        .utc()
        .format();
      const formValue = this._fS.announcementForm.value;
      var announcementBody: any = {
        title: formValue.title,
        description: formValue.desc,
        startOn: utcStart,
        endOn: utcEnd,
        isActive: formValue.isActive,
        sites: this.selectedSites,
      };
      //add or edit unit data

      if (this.selectedAnnoucementData != null) {
        announcementBody['id'] = this.selectedAnnoucementData.id;
      }
      this.addUpdateAnnouncementData(announcementBody);
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.announcementForm.controls);
      this._cS.markFormGroupTouched(this._fS.announcementForm);
      if (this.selectedSites?.length == 0) {
        this.showSitesInvalidMessage = true;
      }
    }
  }
  addUpdateAnnouncementData(announcementBody: any) {
    this.isSubmitting = true;
    this._cpS
      .AddOrUpdateAnnouncement(announcementBody)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);
          //hide announcement drawer
          this.isVisibleAnnouncementDrawer = false;
          this.handleCancel(response.result);
          this.isSubmitting = false;
        } else {
          this._cS.displayMessage('error', response.message);
          this.isSubmitting = false;
        }
      });
  }

  handleCancel(data = null) {
    this.isVisibleAnnouncementDrawer = false;
    this.hideAnnoucementDrawer.emit({
      isVisible: this.isVisibleAnnouncementDrawer,
      data: data,
    });
  }
  handleCancelFullScreen() {
    this.isVisibleFullScreenModal = false;
    this._fS.announcementForm.patchValue({
      desc: this.descFullScreen,
    });
    this.editorConfig['minHeight'] = '5rem';
  }

  disabledStartDate = (startValue: Date): boolean => {
    // startValue = new Date(startValue);
    var formEndDate = new Date(this._fS.announcementForm.value.end);
    if (!formEndDate) {
      return false;
    }
    return (
      startValue.getTime() > formEndDate.getTime() ||
      startValue <= this.yesterday
    );
  };

  onFileChange(pFileList: any) {
    this.files = Object.keys(pFileList).map((key: any) => pFileList[key]);
    this.files.forEach((file: any) => {
      this.uploadImageByAngularEditor(file);
    });
  }
  disabledEndDate = (endValue: Date): boolean => {
    var formStartDate = new Date(this._fS.announcementForm.value.start);
    if (!endValue || !formStartDate) {
      return false;
    }
    return endValue.getTime() < this.yesterday.getTime();
  };

  handleStartOpenChange(open: boolean): void {
    if (!open) {
      this.endDatePicker.open();
    }
  }

  handleEndOpenChange(open: boolean): void { }
  //#endregion
}
